import _memoize from 'lodash/memoize';
import { HD, FULL_HD, safetyMargins } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../../tornado/utils/sizes';
import HorizontalCard from '../../../tornado/horizontal-card/horizontalCard.component';
import HorizontalSquare from '../../../tornado/horizontal-square/horizontalSquare.component';

export const defaultContext = makeDefaultStylingContext();

export const WIDTH = {
  [HD]: 640,
  [FULL_HD]: 960,
};

export const HEIGHT = {
  ...SCREEN_HEIGHT,
};

export const PADDING_LEFT = {
  [HD]: 40,
  [FULL_HD]: 40,
};

export const PADDING_TOP = {
  [HD]: safetyMargins.vertical[HD],
  [FULL_HD]: safetyMargins.vertical[FULL_HD],
};

export const PADDING_BOTTOM = {
  [HD]: safetyMargins.vertical[HD],
  [FULL_HD]: safetyMargins.vertical[FULL_HD],
};

export const CONTENT_GAP = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const PADDINGS = {
  [HorizontalCard.Templates.HorizontalCard]: {
    [HD]: 0,
    [FULL_HD]: 0,
  },
  [HorizontalSquare.Templates.HorizontalSquare]: PADDING_LEFT,
};

export const Z_INDEX_FOCUSED = 1;

export const Z_INDEX_UNFOCUSED = 1;

export const colors = {
  background: makeThemeColor(TERTIARY),
  backgroundOverlay: makeThemeColor(PRIMARY, 0.1),
};

export const getContentWidth = (itemTemplate, screenSize) =>
  WIDTH[screenSize] - PADDING_LEFT[screenSize] - (PADDINGS[itemTemplate] ? PADDINGS[itemTemplate][screenSize] : 0);

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    visible: false,
    x: SCREEN_WIDTH[screenSize],
    w: WIDTH[screenSize],
    h: HEIGHT[screenSize],
    color: colors.background[colorMode],
    BackgroundOverlay: {
      color: colors.backgroundOverlay[colorMode],
      w: WIDTH[screenSize],
      h: HEIGHT[screenSize],
    },
    Container: {
      x: PADDING_LEFT[screenSize],
      y: PADDING_TOP[screenSize],
    },
  };
};

export const getFocusedStyle = _memoize(screenSize => ({
  visible: true,
  smooth: {
    x: SCREEN_WIDTH[screenSize] - WIDTH[screenSize],
  },
}));

export const getUnFocusedStyle = _memoize(screenSize => ({
  smooth: {
    x: SCREEN_WIDTH[screenSize],
  },
}));
